import { Component, ViewChild, OnInit, Output, ViewEncapsulation, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository, WindowRef } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import {  KhoaHocs_KhoaHoc } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'
import { EmitType, detach } from '@syncfusion/ej2-base';
import { UploaderComponent, RemovingEventArgs, SelectedEventArgs, SuccessEventArgs, FileInfo } from '@syncfusion/ej2-angular-inputs';

import { DialogComponent, ButtonPropsModel, PositionDataModel, ResizeDirections } from '@syncfusion/ej2-angular-popups';
import { AnimationSettingsModel } from '@syncfusion/ej2-splitbuttons';

import { SelectionService, EditService, SelectionSettingsModel, GridComponent } from '@syncfusion/ej2-angular-grids';
import { MaskedDateTimeService } from '@syncfusion/ej2-angular-calendars';
import { ToolbarService, LinkService, ImageService, HtmlEditorService } from '@syncfusion/ej2-angular-richtexteditor';
import { RichTextEditorComponent, TableService, FileManagerService } from '@syncfusion/ej2-angular-richtexteditor';
import { FileManagerSettingsModel, QuickToolbarSettingsModel } from '@syncfusion/ej2-angular-richtexteditor';
import { createElement, addClass, removeClass, Browser } from '@syncfusion/ej2-base';
import * as CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/htmlmixed/htmlmixed.js';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { FileManagerComponent, FileOpenEventArgs, FileSelectEventArgs } from '@syncfusion/ej2-angular-filemanager';
import { BsModalComponent, BsModalBodyComponent, BsModalService } from 'ng2-bs3-modal';
import { MaskedTextBoxComponent } from '@syncfusion/ej2-angular-inputs';
import { load } from '@progress/kendo-angular-intl';

const swal = require('sweetalert');
@Component({
  selector: 'app-daotao-hocvienedit',
  templateUrl: './hocvienedit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./hocvienedit.component.scss'],
  providers: [ListService, Repository, WindowRef, MaskedDateTimeService, ToolbarService, LinkService, ImageService, HtmlEditorService, TableService, FileManagerService],
  encapsulation: ViewEncapsulation.None
})


export class hocvieneditComponent implements OnInit {
  @ViewChild('modal')
  modal: BsModalComponent;
  @ViewChild('dteChonTaiKhoan') dteChonTaiKhoan: any;

  @ViewChild('mdDanhSachLichHoc') mdDanhSachLichHoc: BsModalComponent;
  @ViewChild('dtedslichhocedit') dtedslichhocedit: any;
  @ViewChild('ejNgaySinh') public ejNgaySinh: MaskedTextBoxComponent;
  public formatDateVao = '00/00/0000';
  public formatDateRa = '00/00/0000';
  public formatDate = '00/00/0000';

  dviid: string;
  inputhinhthucdaotaos: any = [];
  inputchungchis: any = [];
  inputGiangViens: any;
  items = [];
  donviitems = [];
  datas = [];
  inputgioitinhs: any = [{ Id: 1, Name: 'Nam' }, { Id: 2, Name: 'Nữ' }]
  inputphanloais = [{ Id: 0, Ten: 'Dài hạn' }, { Id: 1, Ten: 'Không thường xuyên' }
  ];
  inputtinhtrangs = [{ Id: 0, Ten: 'Dự kiến' }, { Id: 1, Ten: 'Chính thức' }
  ];
  inputphonghocs: any;

  private hostUrl: string = '/';
  // upload
  @ViewChild('uploadObj')
  public uploadObj: UploaderComponent;
  @ViewChild('dialogObj')
  public dialogObj: DialogComponent;
  @ViewChild('filemanagerObj')
  public filemanagerObj: FileManagerComponent;
  public dialogHeader = 'Chọn tệp ảnh';
  public animationSettings: Object = { effect: 'None' };
  public showCloseIcon = true;
  public target = '#target';
  public visible = false;
  public dialogWidth = '850px';
  public contextmenuItems: string[] = ['Open', '|', 'Cut', 'Copy', 'Delete', 'Rename', '|', 'Details'];
  ajaxSettings = {
    url: this.hostUrl + 'FileUpLoadManager/FileOperations',
    getImageUrl: this.hostUrl + 'FileUpLoadManager/GetImage',
    uploadUrl: this.hostUrl + 'FileUpLoadManager/Upload',
    downloadUrl: this.hostUrl + 'FileUpLoadManager/Download'
  };
  public btnClick: EmitType<object> = () => {
    //if (document.getElementById('target').classList.contains('upload-dialog1')) {
    //  document.getElementById('target').classList.remove('upload-dialog1');
    //}
    //document.getElementById('target').classList.add('upload-dialog');
    this.dialogObj.show();
    this.dialogOpen();
    this.filemanagerObj.path = '/';
    this.filemanagerObj.selectedItems = [];
    this.filemanagerObj.refresh();
  }

  // Uploader will be hidden, if Dialog is opened
  public dialogOpen: EmitType<object> = () => {
    document.getElementById('uploadFileManager').style.display = 'none';
  }
  // Uploader will be shown, if Dialog is closed
  public dialogClose: EmitType<object> = () => {
    document.getElementById('uploadFileManager').style.display = 'block';
  }
  OnbeforeSend(args) {

    var data = JSON.parse(args.ajaxSettings.data);
    if (args.action == 'Upload') {
      //data[0]["CodeClass"] = this.codeClass;
      //data[0]["Loai"] = 1;
      data.push({ codeclass: 'ThuVien' });
      data.push({ PathFolder: "~/Upload/ThuVien" });
      data.push({ loai: 1 });
      args.ajaxSettings.data = JSON.stringify(data);
    }
    else {
      data["CodeClass"] = 'ThuVien';
      data["DonVi"] = null;
      data["PathFolder"] = "~/Upload/ThuVien";
      data["Loai"] = 1;
      args.ajaxSettings.data = JSON.stringify(data);
    }

  };
  // File Manager's fileOpen event function
  public onFileOpen(args: FileOpenEventArgs): void {
    let file = (args as any).fileDetails;
    if (file.isFile) {
      args.cancel = true;
      if (file.size <= 0) { file.size = 10000; }
      this.uploadObj.files = [{ name: file.name, size: file.size, type: file.type }];
      // let filterPath = "/Content/Files" + file.filterPath.replace('\\', '/') + file.name;
      let filterPath = '/Upload/ThuVien' + '/' + file.filterPath.replace('\\', '/').replace('\\', '/').replace('\\', '/').replace('\\', '/') + '/' + file.name;
      this.hosoSelect.DuongDanAnh = filterPath;
      this.dialogObj.hide();
      //if (document.getElementById('target').classList.contains('upload-dialog')) {
      //  document.getElementById('target').classList.remove('upload-dialog');
      //}
      //document.getElementById('target').classList.add('upload-dialog1');

    }
  }
  public ngOnDestroy(): void {
    if (document.getElementById('target').classList.contains('upload-dialog')) {
      document.getElementById('target').classList.remove('upload-dialog');
    }
  }

  toolbarSettings = {
    items: ['NewFolder', 'Upload', 'Delete', 'Cut', 'Copy', 'Rename', 'SortBy', 'Refresh', 'Selection', 'View', 'Details']
  };
  contextMenuSettings = {
    file: this.contextmenuItems,
    folder: this.contextmenuItems
  };
  taifile(src: string) {
    console.log(src);
    window.location.href = src;
  }
  deleteFile() {
    this.hosoSelect.DuongDanAnh = null;
  }

  // upload




  alertMsg: any;
  @ViewChild('toolsRTE')
  public rteObj: RichTextEditorComponent;
  public tools: ToolbarModule = {
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
      'LowerCase', 'UpperCase', 'SuperScript', 'SubScript', '|',
      'Formats', 'Alignments', 'NumberFormatList', 'BulletFormatList',
      'Outdent', 'Indent', '|',
      'CreateTable', 'CreateLink', 'Image', 'FileManager', '|', 'ClearFormat', 'Print',
      'SourceCode', 'FullScreen', '|', 'Undo', 'Redo']
  };

  public fileManagerSettings: FileManagerSettingsModel = {
    enable: true,
    path: '',
    ajaxSettings: {
      url: this.hostUrl + 'FileUpLoadManager/FileOperations',
      getImageUrl: this.hostUrl + 'FileUpLoadManager/GetImage',
      uploadUrl: this.hostUrl + 'FileUpLoadManager/Upload',
      downloadUrl: this.hostUrl + 'FileUpLoadManager/Download'
    }
  };





  public quickToolbarSettings: QuickToolbarSettingsModel = {
    table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
  };
  public width: string = '98%';
  // public animationSettings: AnimationSettingsModel = { effect: 'None' };
  // public target: string = '.control-section';
  public maxLength = 20000;
  public textArea: HTMLElement;
  public myCodeMirror: any;
  public value: any;


  public mirrorConversion(e?: any): void {
    const id: string = this.rteObj.getID() + 'mirror-view';
    let mirrorView: HTMLElement = this.rteObj.element.querySelector('#' + id) as HTMLElement;
    const charCount: HTMLElement = this.rteObj.element.querySelector('.e-rte-character-count') as HTMLElement;
    if (e.targetItem === 'Preview') {
      this.textArea.style.display = 'block';
      mirrorView.style.display = 'none';
      this.textArea.innerHTML = this.myCodeMirror.getValue();
      charCount.style.display = 'block';
    } else {
      if (!mirrorView) {
        mirrorView = createElement('div', { className: 'e-content' });
        mirrorView.id = id;
        this.textArea.parentNode.appendChild(mirrorView);
      } else {
        mirrorView.innerHTML = '';
      }
      this.textArea.style.display = 'none';
      mirrorView.style.display = 'block';
      this.renderCodeMirror(mirrorView, this.rteObj.value);
      charCount.style.display = 'none';
    }
  }

  public renderCodeMirror(mirrorView: HTMLElement, content: string): void {
    this.myCodeMirror = CodeMirror(mirrorView, {
      value: content,
      lineNumbers: true,
      mode: 'text/html',
      lineWrapping: true,

    });
  }
  public handleFullScreen(e: any): void {
    const sbCntEle: HTMLElement = document.querySelector('.sb-content.e-view');
    const sbHdrEle: HTMLElement = document.querySelector('.sb-header.e-view');
    const leftBar: HTMLElement = document.querySelector('#left-sidebar');
    if (e.targetItem === 'Maximize') {
      if (Browser.isDevice && Browser.isIos) {
        addClass([sbCntEle, sbHdrEle], ['hide-header']);
      }
      addClass([leftBar], ['e-close']);
      removeClass([leftBar], ['e-open']);
    } else if (e.targetItem === 'Minimize') {
      if (Browser.isDevice && Browser.isIos) {
        removeClass([sbCntEle, sbHdrEle], ['hide-header']);
      }
      removeClass([leftBar], ['e-close']);
      if (!Browser.isDevice) {
        addClass([leftBar], ['e-open']);
      }
    }
  }
  public actionCompleteHandler(e: any): void {
    console.log("actiondsdsd");
    console.log(e);
    if (e.targetItem && (e.targetItem === 'SourceCode' || e.targetItem === 'Preview')) {
      (this.rteObj.sourceCodeModule.getPanel() as HTMLTextAreaElement).style.display = 'none';
      this.mirrorConversion(e);
    } else {
      setTimeout(() => {
        this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
        this.rteObj.toolbarModule.refreshToolbarOverflow();
      }, 400);

    }
  }



  public ngaybatdau: Date = null;
  public ngayketthuc: Date = null;

  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputloaicauhois: any
  indLoading: boolean = false;
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
   bledit: boolean = false;
  currentUser: any;
  dschinhanhs: any;
  dschuongtrinhs: any;
  inputtrinhdos: any;
  inputkenhs: any;
  inputhedaotaos: any;
  dslops: any;


  hosoSelect: any = {
    Id: null, MaHoSo: null, MaNV: null, HoVaTen: null, TenGoiKhac: null, NgaySinh: null, NgaySinh_S: null, KieuNgaySinh: 1, GioiTinh: 1, NoiSinh: null, NoiSinhId: null, NguyenQuan: null, NguyenQuanId: null,
    DanTocId: null, HoKhauThuongTru: null, HoKhauThuongTruId: null, ChoOHienTai: null, ChoOHienTaiId: null, DienThoaiBan: null, DienThoaiNhaRieng: null, DienThoaiDiDong: null, NgheNghiepTuyenDung: null,
    CoQuanTuyenDung: null, NgayVaoNN: null, NgayVaoNganh: null, NgayRaNganh: null, CongViecDuocGiao: null, NgayCTXH: null, CongViecCTXH: null, SoTruongCongTac: null, ChungChiTiengDT: null,
    DaoTaoAN: null, DaoTaoQP: null, ThanhPhanGiaDinhId: null, NgayTuyenDung: null, NgayTuyenDung_S: null,
    SucKhoeId: null, NhomMauId: null,// dữ liệu này text
    CanNang: null, DoiTuongChinhSachId: null, HangThuongBinh: null, SoCMND: null, NgayCapCMND: null, NoiCapCMND: null,
    LoaiNhanVienId: null, DonViId: null, BoPhanId: null, ChucVuId: null, TonGiaoId: null,
    NoiSinhIdSelect: null, NguyenQuanIdSelect: null, ChoOHienTaiIdSelect: null, HoKhauThuongTruIdSelect: null, SoHieu: null
    , ImageUrl: null, ChieuCao: null, Created: null, CreatedBy: null, Modified: null, ModifiedBy: null, NgayNghiViec: null

    , Email: null, TrinhDo: null, NguyenVong: null, NguonKenh: null, TruongHoc: null, HeDaoTao: null
    , NameParent: null, PhoneParent: null, FacebookParent: null
    , NameDad: null, PhoneDad: null, FacebookDad: null, ElearningBegin: null, ElearningEnd: null
    , LopId: null, IdConsult: null, Notes: null, TaiKhoan: null, MatKhau: null
    , DSLop: [], HocVienTiemNangId: null
    , TichLuy: null, TongNo: null, TienThua: null
    //, DSLoaiCanBo: null
  };
  nhomdtid: string = null;
  hoatdong: string = null;
  inputloais: any = [{ Id: 0, Ten: 'Đúng sai' }, { Id: 1, Ten: 'Một lựa chọn' }, { Id: 2, Ten: 'Nhiều lựa chọn' }, { Id: 3, Ten: 'Tự luận' }]

  inputmonhocs: any;
  inputloaikhoanluongs: any = [{ Id: 1, Name: 'Thu nhập thường xuyên' }, { Id: 2, Name: 'Thu nhập không thường xuyên' }, { Id: 3, Name: 'Khấu trừ thường xuyên' }, { Id: 4, Name: 'Khấu trừ không thường xuyên' }]
  inputloaikieunhaps: any = [{ Id: 1, Name: 'Số tiền' }, { Id: 2, Name: 'Tỷ lệ (%)' }, { Id: 3, Name: 'Hệ số' }]
  inputloaikhoans: any;
  inputloaithis: any;
  inputtaikhoantaisans: any;
  inputmucdocauhois: any;

  file: any;
  idnew: string;
  hienthianh: any;

  @Output() save: EventEmitter<any> = new EventEmitter();

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };


  constructor(private _dataService: ListService, public repo: Repository) {


  }

  ngOnInit(): void {
    document.getElementById('target').classList.add('upload-dialog1');
    document.getElementById('defaultfileupload').style.display = 'none';
  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngAfterViewInit() {


    //setTimeout(() => {
    //  this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
    //  this.rteObj.toolbarModule.refreshToolbarOverflow();
    //}, 400);


  }




  // @HostListener('document:keydown', ['$event'])
  // public handleKeyboardEvent(event: KeyboardEvent): void {

  //   if(event.key==="F9")
  //   {
  //       this.saveproduct();
  //   }
  //   event.stopPropagation();

  // }
  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return  item.Ten.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma.toLowerCase().indexOf(term) > -1 || item.Ten.toLowerCase().indexOf(term) > -1;
  }
  phanheid: string;
  tId: string;
  loadDataInit(nhomdoituongid: string, id: string, donviid: string, lopid: string, tenlop: string, rowHocVienTiemNang: any) {

    
    this.phanheid = nhomdoituongid;
    this.tId = id;
    this.dviid = donviid;
    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {
      let data = JSON.parse(authlogin);
      this.currentUser = data;
      var giatri = data.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }

      this.repo.getRequest("api/hoso/combohangmuc/")
        .subscribe(response => {
          this.items = response;

        });
      this.repo.getRequest("api/hoso/donvicaylist/", { phanloaiId: -1, giaithe: 1 })
        .subscribe(response => {
          this.donviitems = response;

        });
      this.repo.postRequest("api/hoso/combonhansuhotro", { DonViId: this.dviid})
        .subscribe(response => {
          this.inputGiangViens = response;
        });
      this.repo.getRequest("api/hoso/conmonlist/", { entityName: 'DM_HinhThucDaoTao' })
        .subscribe(response => {
          this.inputhinhthucdaotaos = response;
        });
      this.repo.getRequest("api/hoso/combochungchi/")
        .subscribe(response => {
          this.inputchungchis = response;
        });

      this.repo.postRequest('api/login/gettrungtam2s', { UserName: this.currentUser.user_name })
        .subscribe(response => {
          this.dschinhanhs = response;
          
        });

      this.repo.postRequest('api/hoso/combolophoc', { UserName: this.currentUser.user_name, DonViId: this.dviid })
        .subscribe(response => {
          this.dslops = response;

        });


    }
  

    //this.hosoSelect.AnhString = null;
    this.hienthianh = false;
    $('#preview').attr('src', "/assets/img/anhdt.gif");


    this.hosoSelect = {
      Id: null, MaHoSo: null, MaNV: null, HoVaTen: null, TenGoiKhac: null, NgaySinh: null, NgaySinh_S: null, KieuNgaySinh: 1, GioiTinh: 1, NoiSinh: null, NoiSinhId: null, NguyenQuan: null, NguyenQuanId: null,
      DanTocId: null, HoKhauThuongTru: null, HoKhauThuongTruId: null, ChoOHienTai: null, ChoOHienTaiId: null, DienThoaiBan: null, DienThoaiNhaRieng: null, DienThoaiDiDong: null, NgheNghiepTuyenDung: null,
      CoQuanTuyenDung: null, NgayVaoNN: null, NgayVaoNganh: null, NgayRaNganh: null, CongViecDuocGiao: null, NgayCTXH: null, CongViecCTXH: null, SoTruongCongTac: null, ChungChiTiengDT: null,
      DaoTaoAN: null, DaoTaoQP: null, ThanhPhanGiaDinhId: null, NgayTuyenDung: null, NgayTuyenDung_S: null,
      SucKhoeId: null, NhomMauId: null,// dữ liệu này text
      CanNang: null, DoiTuongChinhSachId: null, HangThuongBinh: null, SoCMND: null, NgayCapCMND: null, NoiCapCMND: null,
      LoaiNhanVienId: null, DonViId: this.dviid, BoPhanId: null, ChucVuId: null, TonGiaoId: null,
      NoiSinhIdSelect: null, NguyenQuanIdSelect: null, ChoOHienTaiIdSelect: null, HoKhauThuongTruIdSelect: null, SoHieu: null
      , ImageUrl: null, ChieuCao: null, Created: null, CreatedBy: null, Modified: null, ModifiedBy: null, NgayNghiViec: null

      , Email: null, TrinhDo: null, NguyenVong: null, NguonKenh: null, TruongHoc: null, HeDaoTao: null
      , NameParent: null, PhoneParent: null, FacebookParent: null
      , NameDad: null, PhoneDad: null, FacebookDad: null, ElearningBegin: null, ElearningEnd: null
      , LopId: null, IdConsult: null, Notes: null, TaiKhoan: null, MatKhau: null
      , DSLop: [], HocVienTiemNangId: null
      , TichLuy: null, TongNo: null, TienThua: null
    };
    this.ngaybatdau = null;
    this.ngayketthuc = null;

    this.hosoSelect.DonViId = parseInt(this.dviid);

    if (id === null) {


      this.hosoSelect.Created = new Date();
      this.hosoSelect.CreatedBy = this.currentUser.user_name;
      this.hosoSelect.Modified = new Date();
      this.hosoSelect.ModifiedBy = this.currentUser.user_name;

      if (lopid != null)
        this.hosoSelect.DSLop.push(parseInt(lopid));

      if (rowHocVienTiemNang != null) {

        this.hosoSelect.DonViId = rowHocVienTiemNang.DonViId;
        this.hosoSelect.HoVaTen = rowHocVienTiemNang.HoVaTen;
        this.hosoSelect.TenGoiKhac = rowHocVienTiemNang.TenGoiKhac;
        if (rowHocVienTiemNang.NgaySinh!=null)
        this.hosoSelect.NgaySinh = new Date(rowHocVienTiemNang.NgaySinh);
        this.hosoSelect.NameParent = rowHocVienTiemNang.TenPhuHuynh;
        this.hosoSelect.PhoneParent = rowHocVienTiemNang.DienThoaiDiDong;
        this.hosoSelect.IdConsult = rowHocVienTiemNang.IdConsult;
        this.hosoSelect.NguyenVong = rowHocVienTiemNang.NguyenVong;
        this.hosoSelect.TruongHoc = rowHocVienTiemNang.TruongHoc;
        this.hosoSelect.NguonKenh = rowHocVienTiemNang.KenhId;
        this.hosoSelect.TrinhDo = rowHocVienTiemNang.TrinhDoId;
        this.hosoSelect.HeDaoTao = rowHocVienTiemNang.HeDaoTaoId;
        this.hosoSelect.GioiTinh = rowHocVienTiemNang.GioiTinhId;
        this.hosoSelect.ElearningBegin = new Date();
        this.hosoSelect.FacebookParent = rowHocVienTiemNang.FacebookParent;
        this.hosoSelect.HocVienTiemNangId = rowHocVienTiemNang.Id;

      }

      //this.hosoSelect.PhanLoai = 0;
      //this.hosoSelect.TinhTrang = 1;
      //this.hosoSelect.TrangThai2 = true;

      //this.repo.postRequest("api/daotao/getthongtinhoso/", { id: null, status: this.dviid })
      //  .subscribe(response => {
      //    this.hosoSelect.Ma = response.MaLop;
      //  });

      //setTimeout(() => {
      //  this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
      //  this.rteObj.toolbarModule.refreshToolbarOverflow();
      //}, 400);
    }
    else {
      this.bledit = true;
      console.log("t11");
      this.repo.postRequest("api/hoso/mb_getthongtinhoso/", { id: id, status: 0 })
        .subscribe(response => {
          this.hosoSelect = response;
          console.log(this.hosoSelect);
          if (this.hosoSelect.NgaySinh != null)
            this.hosoSelect.NgaySinh = new Date(this.hosoSelect.NgaySinh);
          else
            this.hosoSelect.NgaySinh = null;

          if (this.hosoSelect.NgayNghiViec != null)
            this.hosoSelect.NgayNghiViec = new Date(this.hosoSelect.NgayNghiViec);
          else
            this.hosoSelect.NgayNghiViec = null;

          if (this.hosoSelect.NgayVaoDang != null)
            this.hosoSelect.NgayVaoDang = new Date(this.hosoSelect.NgayVaoDang);
          else
            this.hosoSelect.NgayVaoDang = null;

          if (this.hosoSelect.NgayRaDang != null)
            this.hosoSelect.NgayRaDang = new Date(this.hosoSelect.NgayRaDang);
          else
            this.hosoSelect.NgayRaDang = null;
          if (this.hosoSelect.NgayVaoDangCT != null)
            this.hosoSelect.NgayVaoDangCT = new Date(this.hosoSelect.NgayVaoDangCT);
          else
            this.hosoSelect.NgayVaoDangCT = null;
          if (this.hosoSelect.NgayCapTheDang != null)
            this.hosoSelect.NgayCapTheDang = new Date(this.hosoSelect.NgayCapTheDang);
          else
            this.hosoSelect.NgayCapTheDang = null;
          if (this.hosoSelect.NgayVaoDoan != null)
            this.hosoSelect.NgayVaoDoan = new Date(this.hosoSelect.NgayVaoDoan);
          else
            this.hosoSelect.NgayVaoDoan = null;
          if (this.hosoSelect.Id === 0)
            this.hosoSelect.TonGiaoId = 1609;

          if (this.hosoSelect.ElearningBegin != null)
            this.hosoSelect.ElearningBegin = new Date(this.hosoSelect.ElearningBegin);
          else
            this.hosoSelect.ElearningBegin = null;
          if (this.hosoSelect.ElearningEnd != null)
            this.hosoSelect.ElearningEnd = new Date(this.hosoSelect.ElearningEnd);
          else
            this.hosoSelect.ElearningEnd = null;


          //this.hosoSelect.Created = response.Created;
          //this.hosoSelect.CreatedBy = response.CreatedBy;
          this.hosoSelect.Modified = new Date();
          this.hosoSelect.ModifiedBy = this.currentUser.user_name;

          //setTimeout(() => {
          //  this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
          //  this.rteObj.toolbarModule.refreshToolbarOverflow();
          //}, 400);

        });
    }



  }
  Tai_Anh() {

    this.hosoSelect.XoaAnh = 1;
    $("#File").click();
  }
  Xoa_Anh() {

    this.hosoSelect.XoaAnh = 0;
    $('#preview').attr('src', "/assets/img/anhdt.gif");
  }
  getFiles(event) {
    console.log("tt");
    //console.log(event);
    this.file = event.target.files;
    if (!this.file[0].type.match("image.*")) {
      alert("Tệp chọn không phải kiểu ảnh.");
      event.srcElement.value = null;
      return;
    }

    var reader = new FileReader();
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsBinaryString(this.file[0]);

  }
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.hosoSelect.AnhString = btoa(binaryString);  // Converting binary string data.

    $('#preview').attr('src', "data:image/png;base64," + this.hosoSelect.AnhString + "");

  }
  //  keyTenPress(event: any) { 
  //      if (event.which === 13) {
  //        this.slLoaiKhoanLuong.focus();
  //          event.preventDefault();
  //        }
  //}

  public closeModal() {
    this.save.emit(null);
  }
  public saveproduct() {
    if (this.hosoSelect.Id == null)
      this.hosoSelect.Id = 0;

    // Validate required fields
    if (this.hosoSelect.Id == 0) {
      if (this.hosoSelect.TaiKhoan === null || this.hosoSelect.TaiKhoan === '') {
        swal('Cảnh báo!', "Bạn chưa nhập tài khoản/CCCD", 'warning');
        return;
      }
    }

    if (this.hosoSelect.HoVaTen === null || this.hosoSelect.HoVaTen === '') {
      swal('Cảnh báo!', "Bạn chưa nhập họ tên nhân viên", 'warning');
      return;
    }

    if (this.hosoSelect.DonViId === null) {
      swal('Cảnh báo!', "Bạn chưa nhập Đơn vị", 'warning');
      return;
    }

    // Prepare data for saving
    this.prepareDataForSaving();

    // Call API to save
    this.callSaveAPI();
  }

  private prepareDataForSaving() {
    if (this.hosoSelect.NoiSinhIdSelect != null && this.hosoSelect.NoiSinhIdSelect != {})
      this.hosoSelect.NoiSinhId = this.hosoSelect.NoiSinhIdSelect.id;
    if (this.hosoSelect.NguyenQuanIdSelect != null && this.hosoSelect.NguyenQuanIdSelect != {})
      this.hosoSelect.NguyenQuanId = this.hosoSelect.NguyenQuanIdSelect.id;
    if (this.hosoSelect.HoKhauThuongTruIdSelect != null && this.hosoSelect.HoKhauThuongTruIdSelect != {})
      this.hosoSelect.HoKhauThuongTruId = this.hosoSelect.HoKhauThuongTruIdSelect.id;
    if (this.hosoSelect.ChoOHienTaiIdSelect != null && this.hosoSelect.ChoOHienTaiIdSelect != {})
      this.hosoSelect.ChoOHienTaiId = this.hosoSelect.ChoOHienTaiIdSelect.id;

    // Format dates
    if (this.hosoSelect.NgayVaoDang != null)
      this.hosoSelect.NgayVaoDang_S = this.hosoSelect.NgayVaoDang.getDate() + '/' + (this.hosoSelect.NgayVaoDang.getMonth() + 1) + '/' + this.hosoSelect.NgayVaoDang.getFullYear();
    if (this.hosoSelect.NgayRaDang != null)
      this.hosoSelect.NgayRaDang_S = this.hosoSelect.NgayRaDang.getDate() + '/' + (this.hosoSelect.NgayRaDang.getMonth() + 1) + '/' + this.hosoSelect.NgayRaDang.getFullYear();
    if (this.hosoSelect.NgayVaoDangCT != null)
      this.hosoSelect.NgayVaoDangCT_S = this.hosoSelect.NgayVaoDangCT.getDate() + '/' + (this.hosoSelect.NgayVaoDangCT.getMonth() + 1) + '/' + this.hosoSelect.NgayVaoDangCT.getFullYear();
    if (this.hosoSelect.NgayCapTheDang != null)
      this.hosoSelect.NgayCapTheDang_S = this.hosoSelect.NgayCapTheDang.getDate() + '/' + (this.hosoSelect.NgayCapTheDang.getMonth() + 1) + '/' + this.hosoSelect.NgayCapTheDang.getFullYear();
    if (this.hosoSelect.NgayVaoDoan != null)
      this.hosoSelect.NgayVaoDoan_S = this.hosoSelect.NgayVaoDoan.getDate() + '/' + (this.hosoSelect.NgayVaoDoan.getMonth() + 1) + '/' + this.hosoSelect.NgayVaoDoan.getFullYear();
  }

  private callSaveAPI(ignoreDuplicate: boolean = false) {
    // Add ignore duplicate flag to the request
    const requestData = { ...this.hosoSelect, IgnoreDuplicate: ignoreDuplicate };

    $('#loading').show();
    this.repo.postRequest("api/hoso/addorupdate_hocvien_CtuV2", requestData)
      .subscribe(response => {
        $('#loading').hide();
        this.handleSaveResponse(response);
      }, error => {
        $('#loading').hide();
        console.error('Save error:', error);
        swal('Lỗi!', 'Có lỗi xảy ra khi lưu dữ liệu!', 'error');
      });
  }

  private handleSaveResponse(response: any) {
    // Handle different response formats
    if (typeof response === 'string') {
      if (response === "OK") {
        this.save.emit(this.hosoSelect);
        return;
      } else {
        swal('Cảnh báo!', response, 'warning');
        return;
      }
    }

    // Handle object response with Status property
    if (response && typeof response === 'object') {
      switch (response.status) {
        case 'OK':
          swal('Thành công!', 'Lưu học sinh thành công!', 'success');
          this.save.emit(this.hosoSelect);
          break;

        case 'DUPLICATE_WARNING':
          this.handleDuplicateWarning(response);
          break;

        case 'ERROR':
          swal('Lỗi!', response.message || 'Có lỗi xảy ra!', 'error');
          break;

        default:
          // Handle legacy response format
          console.log(response);
          if (response.status=="OK") {
            this.save.emit(this.hosoSelect);
          } else {
            swal('Cảnh báo!', response.message || 'Phản hồi không xác định từ server!', 'warning');
          }
          break;
      }
    } else {
      swal('Cảnh báo!', 'Phản hồi không xác định từ server!', 'warning');
    }
  }

  private handleDuplicateWarning(response: any) {
    const message = response.message || 'Phát hiện thông tin trùng lặp!';

    swal({
      title: 'Cảnh báo trùng lặp!',
      text: '',
      icon: 'warning',
      content: {
        element: "div",
        attributes: {
          innerHTML: `<div style="text-align: left; white-space: pre-line;">${message}</div>`
        }
      },
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
          className: "btn-secondary"
        },
        confirm: {
          text: 'Tiếp tục lưu',
          value: true,
          visible: true,
          className: "btn-warning"
        }
      },
      dangerMode: true
    }).then(willSave => {
      if (willSave) {
        // User confirmed to save despite duplicate warning
        this.callSaveAPI(true); // Call with ignoreDuplicate = true
      }
      // If user cancels, do nothing (stay on the form)
    });
  }


  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }

  adddata_danhsachlichhoc() {
    if (this.hosoSelect.Id !== null) {
      this.dtedslichhocedit.loadDataInit(this.hosoSelect.Id, KhoaHocs_KhoaHoc.id);
      this.mBackdrop = setTimeout(() => {
        this.haveBackdrop();
      }, 500);
      this.mdDanhSachLichHoc.open();
    }
    else {
      swal('Lỗi!', 'Phải thêm lớp học trước khi thêm lịch học!.', 'error');
      return;
    }

  }
  save_danhsachlichhoc(doituong: any) {
    this.mdDanhSachLichHoc.close();
  }


  removeaccount() {
    this.hosoSelect.TaiKhoan = null;
    this.hosoSelect.UserId = null;
  }
  adddata() {
    this.dteChonTaiKhoan.loadDataInit(null, 0, this.phanheid, null);
    this.modal.open();
  }
  savetaikhoan(doituong1: any) {
    console.log(doituong1)
    this.hosoSelect.TaiKhoan = doituong1.UserName;
    this.hosoSelect.UserId = doituong1.Id;
    this.modal.close();
  }


  //=========================them chuc nang chi tiet====================
  //@ViewChild('mdBaoLuuNghiHoc') mdBaoLuuNghiHoc: BsModalComponent;
  //@ViewChild('baoluunghihocedit') baoluunghihocedit: any;
  modalTitle: any;
  @ViewChild('mdDanhSachLopHoc1') mdDanhSachLopHoc1: BsModalComponent;
  @ViewChild('danhsachlophocedit1') danhsachlophocedit1: any;
  @ViewChild('mdDangKyHoc1') mdDangKyHoc1: BsModalComponent;
  @ViewChild('dangkyhocedit1') dangkyhocedit1: any;
  @ViewChild('mdPhatDungCu1') mdPhatDungCu1: BsModalComponent;
  @ViewChild('phatdungcuedit1') phatdungcuedit1: any;

  DanhSachLopHoc1() {
    if (this.tId != null) {
      this.modalTitle = "Danh sách lớp đang theo học của HV " + this.hosoSelect.HoVaTen;
      this.danhsachlophocedit1.loadDataInit(this.tId, this.phanheid);
      this.mBackdrop = setTimeout(() => {
        this.haveBackdrop();
      }, 500);
      this.mdDanhSachLopHoc1.open();
    }
    else {
      swal('Cảnh báo!', "Vui lòng chọn học sinh cần xem danh sách lớp học.", 'warning');
    }
  }
  DangKyHoc1() {
    if (this.tId != null) {
      this.modalTitle = "Hồ sơ học phíc của học sinh " + this.hosoSelect.HoVaTen;
      this.dangkyhocedit1.loadDataInit(this.tId, this.phanheid, this.hosoSelect.HoVaTen);
      this.mBackdrop = setTimeout(() => {
        this.haveBackdrop();
      }, 500);
      this.mdDangKyHoc1.open();
    }
    else {
      swal('Cảnh báo!', "Vui lòng chọn học sinh cần xem học phí.", 'warning');
    }
  }
  PhatDungCu1() {
    if (this.tId != null) {
      this.modalTitle = "Danh sách phát dụng cụ của " + this.hosoSelect.HoVaTen;
      this.phatdungcuedit1.loadDataInit(this.tId, this.hosoSelect.HoVaTen, this.phanheid);
      this.mBackdrop = setTimeout(() => {
        this.haveBackdrop();
      }, 500);
      this.mdPhatDungCu1.open();
    }
    else {
      swal('Cảnh báo!', "Vui lòng chọn học sinh cần xem danh sách phát dụng cụ.", 'warning');
    }
  }
  saveModal_DoiMatKhau1(doituong: any) {
    this.mdDanhSachLopHoc1.close();
    //this.mdDoiMatKhau.close();
    //this.mdDoiTaiKhoan.close();   
    //this.mdPhanLop.close();
    //this.mdLichSuChuyenLop.close();
    this.mdDangKyHoc1.close();
    this.mdPhatDungCu1.close();
    //this.mdThongKeDiemDanh.close();
  }
  BaoLuuNghiHoc1() {
    //if (this.tId != null) {
    //  this.modalTitle = "Bảo lưu - nghỉ học";
    //  this.baoluunghihocedit.loadDataInit(this.phanheid, null, this.dviid, null, this.tId);
    //  this.mBackdrop = setTimeout(() => {
    //    this.haveBackdrop();
    //  }, 500);
    //  this.mdBaoLuuNghiHoc.open();
    //}
    //else {
    //  swal('Cảnh báo!', "Vui lòng chọn học sinh cần bảo lưu - nghỉ học.", 'warning');
    //}
  }

  saveModal_KhoaTaiKhoan1(doituong: any) {
    //this.mdBaoLuuNghiHoc.close();
    //this.mdKhoaTaiKhoan.close();
    //this.mdChotSoBuoiHoc.close();
    //this.mdPhanHocVien.close();
   
  }

  onNameBlur(): void {
    // Only generate username if the name field has a value and 
    // either the account field is empty or no ID exists yet (new record)
    if (this.hosoSelect.HoVaTen && this.hosoSelect.Id == null && !this.hosoSelect.TaiKhoan) {
      this.hosoSelect.TaiKhoan = this.generateUsername(this.hosoSelect.HoVaTen);
    }
  }
  /**
 * Generates a username from the full name by taking the first name + initials of last name and middle name
 * The username will have no spaces and no accents
 * @param fullName The full name to generate username from
 */
  generateUsername(fullName: string): string {
    if (!fullName || fullName.trim() === '') {
      return '';
    }

    // Remove extra spaces and split the name
    const nameParts = fullName.trim().split(/\s+/);

    if (nameParts.length === 0) return '';

    // Extract parts of the name
    const lastName = nameParts[0];
    const firstName = nameParts[nameParts.length - 1];

    // Get the middle name initials (if any)
    let middleInitials = '';
    for (let i = 1; i < nameParts.length - 1; i++) {
      if (nameParts[i]) {
        middleInitials += nameParts[i].charAt(0);
      }
    }

    // Combine firstName + initial of lastName + middleInitials
    const lastNameInitial = lastName.charAt(0);
    let username = firstName + lastNameInitial + middleInitials;

    // Remove accents and special characters using ConvertToUnsign3 function
    username = this.removeAccents(username.toLowerCase());

    // Remove any remaining non-alphanumeric characters
    username = username.replace(/[^a-z0-9]/g, '');

    return username;
  }

  /**
   * Remove accents from a string (Vietnamese diacritics)
   * @param str String with accents
   * @returns String without accents
   */
  removeAccents(str: string): string {
    str = str.normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D');
    return str;
  }

}

